import { IProduct, ISfh } from "../../fetchOrderProducts";

export function isSfh(product: IProduct): product is ISfh {
  return "specificationId" in product && product.specificationId === "SFH";
}
